/**
 * @description 富文本的公用只读组件
 * @author duanjun
 * @date
 */

import './simditorText.scss';

import React, { Component } from 'react';
import { fetch } from '@umu/umu-fetch';
import { components } from 'common';
const { If } = components;

import { resizeRichTextImage } from './util';
import {
    WrapperUseMobileIframeLandscapeDisplayManager,
    IWrapperUseMobileIframeLandscapeDisplayProps,
} from '../../services/responsiveDisplay/course';
import { isMobile } from '@umu/umu-ua';

interface IProps extends IWrapperUseMobileIframeLandscapeDisplayProps {
    multimediaId?: string;
    cnt?: string;
    afterRender?(content: string): void; // 渲染完成
    fulltextLoaded?(): void; // 获取到富文本
    checkRichContent?(content: string): void;
    handleContentClick?: (e: React.MouseEvent) => void;
}

interface IState {
    multimediaContent?: string;
}

const contentExcludeScript = (str: string = '') => {
    return str.replace(/<script/g, '&lt;script').replace(/<\/script>/g, '&lt;/script&gt;')
};

// 替换原来的
const IMG_WIDTH_600_REG = /@l_1,f_png,w_600/gi;
const IMG_WIDTH_1200 = '@l_1,f_png,w_1200';
class SimditorText extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            // multimediaContent: '',
        };
    }

    public componentDidMount() {
        const { multimediaId, cnt, afterRender } = this.props;
        if (!multimediaId || multimediaId === '0') {
            this.setState({ multimediaContent: contentExcludeScript(cnt) }, () => {
                if (typeof afterRender === 'function') {
                    afterRender(cnt || '');
                }
            });
        } else {
            this.getRichText(multimediaId);
        }
    }

    public getRichText = (id: string) => {
        fetch
            .get('/ajax/multimedia/fulltextinfo', {
                top_section_id: id,
            })
            .then((result: any) => {
                const data = result.data;
                const { afterRender, fulltextLoaded } = this.props;
                if (result.status) {
                    if (data && data.length === 0) {
                        this.setState({ multimediaContent: '' }, () => {
                            if (typeof afterRender === 'function') {
                                afterRender('');
                            }
                        });
                    } else {
                        const { checkRichContent } = this.props;
                        if (checkRichContent) {
                            checkRichContent(data.content);
                        }
                        data.content = contentExcludeScript(resizeRichTextImage(data.content || '', document.body.clientWidth - 32));
                        this.setState({ multimediaContent: data.content }, () => {
                            if (typeof afterRender === 'function') {
                                afterRender(data.content);
                            }
                        });
                    }
                }
                if (typeof fulltextLoaded === 'function') {
                    fulltextLoaded();
                }
            });
    };

    public shouldComponentUpdate(nextProps: IProps) {
        // 为了防止过多的渲染
        if (nextProps.multimediaId === this.props.multimediaId && this.state.multimediaContent !== undefined) {
            return false;
        }
        return true;
    }

    public render() {
        const { multimediaContent } = this.state;
        let content = multimediaContent || '';
        if (multimediaContent) {
            content = multimediaContent.replace(IMG_WIDTH_600_REG, IMG_WIDTH_1200);
        }
        // iframe场景富文本的超链接进行外跳
        // see https://stackoverflow.com/questions/36429732/how-make-lodash-replace-all-occurrence-in-a-string
        if (this.props._isIframe) {
            content = content.split('<a').join(`<a target="_blank"`);
        }
        const { multimediaId, cnt, handleContentClick = () => {} } = this.props;
        let ret = <div className={`simditor-body ${isMobile ? 'in-mobile' : ''}`} onClick={handleContentClick} dangerouslySetInnerHTML={{ __html: content || '' }}></div>;
        
        if (!multimediaId || multimediaId === '0') {
            ret = <div className="plain-text-content">{cnt}</div>;
        }

        return (
            <If condition={!!multimediaContent}>
                <div className="simditor">{ret}</div>
            </If>
        );
    }
}

export default WrapperUseMobileIframeLandscapeDisplayManager(SimditorText);
